.eo{color:var(--brand-primary);}